import { SourceDataInitials } from '@/constants/SourceDataInitials';
import ISymbolDetails from './ISymbolDetails';

const dbDetails: ISymbolDetails = {
    id: '1',
    name: 'TOTAL Comp Database',
    symbol: SourceDataInitials.Database,
    title: 'TOTAL Comp Database'
};
const mlsDetails: ISymbolDetails = {
    id: '2',
    name: 'Your Area MLS',
    symbol: SourceDataInitials.Mls,
    title: 'MLS'
};
const prDetails: ISymbolDetails = {
    id: '3',
    name: 'Public Records',
    symbol: SourceDataInitials.PublicRecords,
    title: 'Public Records'
};
const seDetails: ISymbolDetails = {
    id: '4',
    name: 'SmartExchange',
    symbol: SourceDataInitials.SmartExchange,
    title: 'SmartExchange'
};
const cvDetails: ISymbolDetails = {
    id: '5',
    name: 'Custom Value',
    symbol: SourceDataInitials.CustomValue,
    title: 'Custom Value'
};
const utDetails: ISymbolDetails = {
    id: '',
    name: 'User Override',
    symbol: SourceDataInitials.UserOverride,
    title: 'User manually changed the value'
};
const ffDetails: ISymbolDetails = {
    id: '',
    name: 'Form Filler',
    symbol: SourceDataInitials.FormFiller,
    title: 'Form Filler Override'
};
const fieldDetails: ISymbolDetails = {
    id: '',
    name: '',
    symbol: SourceDataInitials.FieldData,
    title: ''
};
const transferDetails: ISymbolDetails = {
    id: '',
    name: '',
    symbol: SourceDataInitials.TransferData,
    title: ''
};
const cascadeDetails: ISymbolDetails = {
    id: '',
    name: '',
    symbol: SourceDataInitials.CascadeData,
    title: ''
};
const defaultDetails: ISymbolDetails = {
    id: '',
    name: '',
    symbol: SourceDataInitials.None,
    title: ''
};

export default {
    /**
     * Get a SymbolDetails object based upon the given symbol.
     * The "symbols" are a subset of those values found in the SourceDataInitials enum.
     * @param symbol
     * @returns
     */
    getBySymbol(symbol: string): ISymbolDetails {
        switch (symbol.toLowerCase()) {
            case SourceDataInitials.Database:
                return dbDetails;
            case SourceDataInitials.Mls:
                return mlsDetails;
            case SourceDataInitials.PublicRecords:
                return prDetails;
            case SourceDataInitials.SmartExchange:
                return seDetails;
            case SourceDataInitials.CustomValue:
                return cvDetails;
            case SourceDataInitials.UserOverride:
                return utDetails;
            case SourceDataInitials.FormFiller:
                return ffDetails;
            case SourceDataInitials.FieldData:
                return fieldDetails;
            case SourceDataInitials.TransferData:
                return transferDetails;
            case SourceDataInitials.CascadeData:
                return cascadeDetails;
            default:
                return defaultDetails;
        }
    },

    isSourceData(symbolDetails: ISymbolDetails, initials: SourceDataInitials): boolean {
        const result = symbolDetails.symbol.toLowerCase() === initials;
        return result;
    }
};
